import { render, staticRenderFns } from "./SchemePension.vue?vue&type=template&id=7d8c4baa&scoped=true&"
import script from "./SchemePension.vue?vue&type=script&lang=js&"
export * from "./SchemePension.vue?vue&type=script&lang=js&"
import style0 from "./SchemePension.vue?vue&type=style&index=0&id=7d8c4baa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../RetirementPlanner.Demo/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d8c4baa",
  null
  
)

export default component.exports